<template>
  <div id="app">
    <div v-if="showPageLoading" id="page-load">
      <div class="centered">
        <img src="/img/loading.gif" alt="Loading">
        <h1>One second while we check your browser...</h1>
      </div>
    </div>
    <div id="install-loading">
      <div id="loading-modal">
        <img class="vertical" src="/img/icons/android-icon-144x144.png" alt="">
        <div class="balls">
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>
          <div class="ball"></div>
        </div>
        <span class="text">Click 'Install'<br>to continue</span>
      </div>
    </div>
    <div v-if="showSkillLevels" id="skill-select">
      <div class="skill-levels">
        <h1>Select your skill level to continue</h1>
        <div class="skill-level" v-on:click="showSkillLevels = false">
          <i class="fas fa-cheeseburger"></i>
          <span>Beginner</span>
        </div>
        <div class="skill-level" v-on:click="showSkillLevels = false">
          <i class="fas fa-utensils-alt"></i>
          <span>Skilled</span>
        </div>
        <div class="skill-level" v-on:click="showSkillLevels = false">
          <i class="fas fa-knife-kitchen"></i>
          <span>Advanced</span>
        </div>
        <div class="skill-level" v-on:click="showSkillLevels = false">
          <i class="fas fa-hat-chef"></i>
          <span>Professional</span>
        </div>
      </div>
    </div>
    <div id="content">
      <img src="/img/logo.png">
      <h1>Access recipes, news, and weather</h1>
      <h2>quickly right from your desktop!</h2>
      <ul>
        <li>Click "<b>Continue</b>"</li>
        <li>Click <b><i class="far fa-plus-circle"></i></b></li>
        <li>Click <b class="button">Install</b></li>
        <li>Enjoy free recipes!</li>
      </ul>
      <button class="continue">Continue</button>
      <span>By Installing the My Recipe Finder app, you agree to the <a href="https://legal.myrecipefinder.co/terms" target="_blank">EULA</a> and <a href="https://legal.myrecipefinder.co/privacy" target="_blank">Privacy Policy</a>.</span>
    </div>
    <div id="handholding">
      <div id="step-1">
        <i class="arrow fas fa-arrow-up" />
        <span>Click "<i class="far fa-plus-circle"></i>" to continue...</span>
      </div>
      <div id="step-2">
        <i class="arrow fas fa-arrow-up" />
        <span>Click "Install" to continue...</span>
      </div>
    </div>
    <div id="footer">
      <span>&copy; {{ new Date().getFullYear() }} My Recipe Finder</span>
      <a href="https://legal.myrecipefinder.co/terms" target="blank">Terms</a>
      <a href="https://legal.myrecipefinder.co/privacy" target="blank">Privacy</a>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showSkillLevels: true,
      showPageLoading: true,
    }
  },
  beforeMount() {
    this.$impressions.sendEvent('app_lp_view');
    this.$install.Listen();
  },
  mounted() {
    setTimeout(() => this.showPageLoading = false, 4000)
    document.querySelectorAll('.continue').forEach(elm => elm.onclick = this.$install.ClickWithLoading);
  }
}
</script>

<style scoped lang="sass">
#app
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  background: linear-gradient(rgba(0,0,0,0.5),rgba(0,0,0,0.5)), url('/img/lp_bg.jpeg') no-repeat center
  background-size: cover

  #content
    position: fixed
    top: 50%
    left: 50%
    transform: translate(-50%,-50%)
    padding: 20px 15px 25px 15px
    width: 900px
    background-color: #fff
    border-radius: 8px
    box-shadow: 1px 1px 5px 1px rgba(0,0,0,0.15)

    img
      display: block
      margin: 0 auto 25px auto
      height: 125px

    h1
      display: block
      margin: 0
      text-align: center
      font: 800 32px 'Merriweather', serif
      color: #333

      b
        font-weight: 900
        color: #111

    h2
      display: block
      margin: 0
      text-align: center
      font: 500 25px 'Poppins', sans-serif
      color: #444

    ul
      display: block
      margin: 20px auto
      width: 220px
      counter-reset: steps-counter
      padding: 0

      li
        font: 500 16px 'Poppins', sans-serif
        color: #444
        margin: 7px 0
        list-style: none

        &:before
          display: inline-block
          width: 55px
          font: 500 16px 'Poppins', sans-serif
          color: #555
          text-align: right
          margin-right: 10px
          counter-increment: steps-counter
          content: "Step " counter(steps-counter) ":"

        b.button
          display: inline-block
          padding: 7px 14px
          background-color: #1871f5
          color: #fff
          font-size: 14px
          border-radius: 4px
          font-weight: 500
          margin-left: 5px

        b i
          vertical-align: middle
          font-size: 22px
          margin-left: 5px

    button
      display: block
      border: none
      outline: none
      border-radius: 6px
      margin:  15px auto 10px
      padding: 30px 115px
      font: 800 30px 'Poppins', sans-serif
      color: #fff
      background-color: #ef5f1a
      cursor: pointer
      text-transform: uppercase
      letter-spacing: 2px
      box-shadow: 1px 1px 5px 1px rgba(0,0,0,0.25)
      transition: background-color 200ms linear

      &:hover
        background-color: #964017

    span
      display: block
      width: 300px
      margin: 0 auto
      text-align: center
      font: 400 12px 'Poppins', sans-serif
      color: #888

      a
        color: #888
        transition: color 200ms linear

        &:hover
          color: #666


  #footer
    position: fixed
    bottom: 10px
    left: 50%
    transform: translateX(-50%)

    span, a
      font: 400 12px 'Poppins', sans-serif
      color: rgba(255,255,255,0.5)
      text-decoration: none
      margin: 0 5px

    a:hover
      text-decoration: underline

#handholding
  display: none
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  background-color: rgba(0,0,0,0.9)
  z-index: 100000

  @keyframes arrowBounce
    0%
      top: 0
    100%
      top: -15px

  #step-1
    display: none
    position: absolute
    top: 25px
    right: 90px

  #step-2
    display: none
    position: absolute
    top: 190px
    right: 170px

  .arrow
    position: absolute
    right: 0
    top: 0
    display: block
    color: #3695ff
    font-size: 100px
    animation: arrowBounce 500ms alternate infinite linear

  span
    display: block
    margin-top: 100px
    text-align: center
    background-color: #fff
    font: 600 25px "Merriweather","Times New Roman"
    padding: 20px 40px
    color: #444
    border-radius: 4px

#page-load
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  background-color: #fff
  z-index: 1000

  .centered
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%,-50%)
    text-align: center

    img
      height: 100px

    h1
      display: block
      margin-top: 45px
      font: 800 25px "Merriweather","Times New Roman"
      color: #444

#install-loading
  display: none
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  background-color: rgba(0,0,0,0.7)
  backdrop-filter: blur(3px)
  z-index: 1000

  .centered
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%,-50%)
    text-align: center

    img
      height: 100px

    h1
      display: block
      margin-top: 45px
      font: 800 25px "Merriweather","Times New Roman"
      color: #444

#skill-select
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  background-color: rgba(0,0,0,0.7)
  backdrop-filter: blur(3px)
  z-index: 500

  .skill-levels
    position: fixed
    top: 50%
    left: 50%
    transform: translate(-50%,-50%)
    padding: 20px 15px 25px 15px
    background-color: #fff
    border-radius: 8px
    box-shadow: 1px 1px 5px 1px rgba(0,0,0,0.15)
    width: 860px
    box-sizing: border-box

    h1
      display: block
      margin: 0 0 15px 0
      text-align: center
      font: 800 32px 'Merriweather', serif
      color: #333

    .skill-level
      position: relative
      display: inline-block
      height: 200px
      width: 200px
      background-color: #165fd0
      margin-right: 10px
      border-radius: 6px
      box-shadow: 1px 1px 5px 2px rgba(0, 0, 0, 0.25)
      cursor: pointer
      transition: background-color 100ms linear

      &:hover
        background-color: #0f397a

      &:last-of-type
        margin-right: 0

      i
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%,calc(-50% - 20px))
        margin:  0 auto
        font-size: 55px
        color: #fff

      span
        position: absolute
        left: 0
        right: 0
        bottom: 20px
        text-align: center
        color: #fff
        font: 600 18px 'Poppins', sans-serif

@keyframes ball1
  25%
    border-color: royalblue
    background-color: royalblue
  50%
    border-color: #fff
    background-color: cornflowerblue

@keyframes ball2
  25%
    border-color: #fff
    background-color: cornflowerblue
  50%
    border-color: royalblue
    background-color: royalblue
  75%
    border-color: #fff
    background-color: cornflowerblue

@keyframes ball3
  50%
    border-color: #fff
    background-color: cornflowerblue
  75%
    border-color: royalblue
    background-color: royalblue
  100%
    border-color: #fff
    background-color: cornflowerblue

@keyframes ball4
  0%
    border-color: #fff
    background-color: cornflowerblue
  75%
    border-color: #fff
    background-color: cornflowerblue
  100%
    border-color: royalblue
    background-color: royalblue

#loading-modal-wrapper
  position: fixed
  top: 0
  left: 0
  width: 100vw
  height: 100vh
  z-index: 100000
  background-color: rgba(0, 0, 0, 0.85)
  display: none

#loading-modal
  position: fixed
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  background-color: #fff
  padding: 15px 15px 10px 15px
  border-radius: 8px
  width: calc(305px - 30px)
  box-sizing: content-box

  .balls
    display: block
    margin: 10px 0 5px
    text-align: center
    box-sizing: content-box

    .ball
      display: inline-block
      margin: 1px
      height: 16px
      width: 16px
      border: 2px solid #fff
      border-radius: 20px
      background-color: cornflowerblue
      box-sizing: content-box

      &:nth-child(1)
        animation: ball1 1000ms linear infinite alternate
      &:nth-child(2)
        animation: ball2 1000ms linear infinite alternate
      &:nth-child(3)
        animation: ball3 1000ms linear infinite alternate
      &:nth-child(4)
        animation: ball4 1000ms linear infinite alternate

  .vertical
    display: block
    margin: 0 auto 10px auto
    width: 30px
    height: 30px
    padding: 10px
    border-radius: 8px
    background-color: lightgrey
    box-sizing: content-box

  .text
    display: block
    text-align: center
    font: 500 24px/1.5 sans-serif
    letter-spacing: 1px
    color: #444
    box-sizing: content-box
</style>
